import { jsPDF } from 'jspdf';

import { includeLeftZero } from './includeLeftZero';
import { formatDate } from './formatDate';
import { phoneMask } from './masks';
import { decrypt } from '../helpers/cryptography';

let feSaudeLogo = new Image();
feSaudeLogo.src = '../assets/img/fesaude-logo.png';
feSaudeLogo.alt = 'FeSaúde Logo';

const makePdf = data => { 
  const doc = new jsPDF('p', 'mm', 'a4');

  doc.setProperties({
    title: `Chamado ${includeLeftZero(data.numeroChamado)}`
  });
  
  const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

  doc.text(
    'SisGeD - Sistema de Gestão de Demandas',
    pageWidth / 2,
    15,
    { align: 'center' }
  );

  doc.setFontSize(15);
  doc.text(
    `Solicitação ${includeLeftZero(data.numeroChamado)} - Status: ${data.status}`,
    pageWidth / 2,
    25,
    { align: 'center' }
  );

  doc.addImage(feSaudeLogo, 'PNG', 15, 10, 16, 17);

  doc.setFontSize(10);
  doc.text(
    `e-mail: ${data.email}`,
    15,
    40,
    { align: 'left' }
  );

  doc.text(
    `Nome do Solicitante: ${data.nome}`,
    15,
    50,
    { align: 'left' }
  );

  doc.text(
    `Telefone: ${data.telefone}`,
    15,
    60,
    { align: 'left' }
  );

  doc.text(
    `Unidade: ${data.unidade}`,
    15,
    70,
    { align: 'left' }
  );

  doc.text(
    `Categoria: ${data.categoria}`,
    15,
    80,
    { align: 'left' }
  );

  doc.text(
    `Subcategoria: ${data.subcategoria}`,
    15,
    90,
    { align: 'left' }
  );

  if (data.loginSistemas) {
    doc.text(
      `Sistema: ${data.loginSistemas.sistema}`,
      15,
      100,
      { align: 'left' }
    );
  }

  if (data?.pontoEletronico?.assunto) {
    doc.text(
      `Assunto: ${data?.pontoEletronico?.assunto}`,
      15,
      100,
      { align: 'left' }
    );
  }

  if (data?.suporteTi?.telContatoTi && data?.suporteTi?.patrimonioTi) {
    doc.text(
      `Telefone de Contato: ${data?.suporteTi?.telContatoTi} - Patrimônio: ${data?.suporteTi?.patrimonioTi}`,
      15,
      100,
      { align: 'left' }
    );
  }

  if (data?.suporteTi?.telContatoTi && !data?.suporteTi?.patrimonioTi) {
    doc.text(
      `Telefone de Contato: ${data?.suporteTi?.telContatoTi}`,
      15,
      100,
      { align: 'left' }
    );
  }

  if (!data?.suporteTi?.telContatoTi && data?.suporteTi?.patrimonioTi) {
    doc.text(
      `Patrimônio: ${data?.suporteTi?.patrimonioTi}`,
      15,
      100,
      { align: 'left' }
    );
  }

  doc.text(
    `SLA: ${data.sla} - Data Inicial: ${formatDate(data.createdAt)} - Data Final: ${data.finalAt ? formatDate(data.finalAt) : ''}`,
    15,
    110,
    { align: 'left' }
  );

  const leftMargin = 15;
  const rightMargin = 15;
  const pageInMm = 210; 
  const linesRelato = data.relato;
  const linesObs = data.obs;

  if (data?.relato?.length > 0 && data?.relato !== '...') {
    doc.text(
      'Descreva brevemente a solicitação:',
      15,
      120,
      { align: 'left' }
    );
  
    const relato = doc.splitTextToSize(linesRelato, (pageInMm - leftMargin - rightMargin));
    doc.text(leftMargin, 130, relato);
  } /* else {
    doc.text(
      'Descreva brevemente a solicitação:',
      15,
      120,
      { align: 'left' }
    );
  } */

  if (data?.obs?.length > 0) {
    doc.text(
      'Observações:',
      15,
      160,
      { align: 'left' }
    );
  
    const obs = doc.splitTextToSize(linesObs, (pageInMm - leftMargin - rightMargin));
    doc.text(leftMargin, 170, obs);
  } else {
    doc.text(
      'Observações:',
      15,
      160,
      { align: 'left' }
    );
  }

  if (data?.subcategoria === 'Criação de Login e/ou e-mail') {
    doc.text(
      `Matrícula: ${decrypt(data.criacaoEmail.registration)} - Nome: ${decrypt(data.criacaoEmail.name)}`,
      15,
      200,
      { align: 'left' }
    );

    doc.text(
      `E-mail sugerido: ${decrypt(data.criacaoEmail.email)}@fesaude.niteroi.rj.gov.br`,
      15,
      210,
      { align: 'left' }
    );

    doc.text(
      `Telefone: ${decrypt(data.criacaoEmail.phone)}  - Data da admissão: ${formatDate(data.criacaoEmail.admissionDate)}`,
      15,
      220,
      { align: 'left' }
    );

    doc.text(
      `Unidade: ${decrypt(data.criacaoEmail.unit)}`,
      15,
      230,
      { align: 'left' }
    );

    doc.text(
      `Cargo: ${decrypt(data.criacaoEmail.job)}`,
      15,
      240,
      { align: 'left' }
    );
  }

  if (data?.subcategoria === 'Solicitação de transporte para locomoção') {
    doc.text(
      `Data do transporte: ${formatDate(data.solicitacaoVeiculo.veiculoData)} - Hora do transporte: ${data.solicitacaoVeiculo.veiculoHora} - Tempo estimado: ${data.solicitacaoVeiculo.veiculoTempo}`,
      15,
      200,
      { align: 'left' }
    );

    doc.text(
      `Nome do passageiro: ${data.solicitacaoVeiculo.veiculoPassageiro} - Telefone do passageiro: ${phoneMask(data.solicitacaoVeiculo.veiculoTelefone)}`,
      15,
      210,
      { align: 'left' }
    );

    doc.text(
      `Endereço da saída: ${data.solicitacaoVeiculo.veiculoSaida}`,
      15,
      220,
      { align: 'left' }
    );

    doc.text(
      `Endereço do destino: ${data.solicitacaoVeiculo.veiculoDestino}`,
      15,
      230,
      { align: 'left' }
    );

    /* const linesMotivo = data.solicitacaoVeiculo.veiculoMotivo;

    doc.text(
      'Motivo da solicitação:',
      15,
      220,
      { align: 'left' }
    );

    const motivo = doc.splitTextToSize(linesMotivo, (pageInMm - leftMargin - rightMargin));
    doc.text(leftMargin, 230, motivo); */
  }

  if (data?.subcategoria === 'Solicitação de transporte de Motoboy') {
    doc.text(
      `Data do transporte: ${formatDate(data.solicitacaoMotoboy.motoboyData)} - Hora do transporte: ${data.solicitacaoMotoboy.motoboyHora} - Tempo estimado: ${data.solicitacaoMotoboy.motoboyTempo}`,
      15,
      200,
      { align: 'left' }
    );

    doc.text(
      `Nome do passageiro: ${data.solicitacaoMotoboy.motoboyPassageiro} - Telefone do passageiro: ${phoneMask(data.solicitacaoMotoboy.motoboyTelefone)}`,
      15,
      210,
      { align: 'left' }
    );

    doc.text(
      `Endereço da saída: ${data.solicitacaoMotoboy.motoboySaida}`,
      15,
      220,
      { align: 'left' }
    );

    doc.text(
      `Endereço do destino: ${data.solicitacaoMotoboy.motoboyDestino}`,
      15,
      230,
      { align: 'left' }
    );

    /* const linesMotivo = data.solicitacaoMotoboy.motoboyMotivo;

    doc.text(
      'Motivo da solicitação:',
      15,
      220,
      { align: 'left' }
    );

    const motivo = doc.splitTextToSize(linesMotivo, (pageInMm - leftMargin - rightMargin));
    doc.text(leftMargin, 230, motivo); */
  }

  if (data?.subcategoria === 'Solicitação de material de escritório') {
    doc.text(
      'Materiais de Escritório',
      15,
      200,
      { align: 'left' }
    );

    doc.text(
      'Qtd',
      180,
      200,
      { align: 'left' }
    );

    data.materiaisEscritorio.map((item, index) => {
      doc.text(
        item.material,
        15,
        210 + (index * 10),
        { align: 'left' }
      );

      doc.text(
        String(item.quantidade),
        180,
        210 + (index * 10),
        { align: 'left' }
      );

      return true;
    });
  }

  if (data?.subcategoria === 'Solicitação de material de limpeza') {
    doc.text(
      'Materiais de Limpeza',
      15,
      200,
      { align: 'left' }
    );

    doc.text(
      'Qtd',
      180,
      200,
      { align: 'left' }
    );

    data.materiaisLimpeza.map((item, index) => {
      doc.text(
        item.material,
        15,
        210 + (index * 10),
        { align: 'left' }
      );

      doc.text(
        String(item.quantidade),
        180,
        210 + (index * 10),
        { align: 'left' }
      );

      return true;
    });
  }

  if (data?.subcategoria === 'Solicitação de material de expediente') {
    doc.text(
      'Materiais de Expediente',
      15,
      200,
      { align: 'left' }
    );

    doc.text(
      'Qtd',
      180,
      200,
      { align: 'left' }
    );

    data.materiaisExpediente.map((item, index) => {
      doc.text(
        item.material,
        15,
        210 + (index * 10),
        { align: 'left' }
      );

      doc.text(
        String(item.quantidade),
        180,
        210 + (index * 10),
        { align: 'left' }
      );

      return true;
    });
  }

  if (data?.subcategoria === 'Manutenção de Equipamentos') {
    doc.text(
      `Equipamento: ${data.equipamentoEngenhariaClinica}`,
      15,
      200,
      { align: 'left' }
    );
  }

  if (data?.subcategoria === 'ERP - (MXM)') {
    doc.text(
      'ERP - (MXM)',
      15,
      200,
      { align: 'left' }
    );

    doc.text(
      data?.erp?.erpNome,
      15,
      205,
      { align: 'left' }
    );

    doc.text(
      data?.erp?.erpEmail,
      105,
      205,
      { align: 'left' }
    );

    doc.text(
      data?.erp?.erpMatricula,
      15,
      210,
      { align: 'left' }
    );

    doc.text(
      data?.erp?.erpUnidade,
      40,
      210,
      { align: 'left' }
    );

    doc.text(
      `Administrador: ${data?.erp?.erpAdministrador}`,
      15,
      220,
      { align: 'left' }
    );

    doc.text(
      `Cadastros Comuns: ${data?.erp?.erpCadastrosComuns}`,
      105,
      220,
      { align: 'left' }
    );

    doc.text(
      `Cadastros Comum Financeiro: ${data?.erp?.erpCadastrosComumFinanceiro}`,
      15,
      225,
      { align: 'left' }
    );

    doc.text(
      `Gestão de Processos: ${data?.erp?.erpGestaoDeProcessos}`,
      105,
      225,
      { align: 'left' }
    );

    doc.text(
      `Compras: ${data?.erp?.erpCompras}`,
      15,
      230,
      { align: 'left' }
    );

    doc.text(
      `Contrato Compras: ${data?.erp?.erpContratoCompras}`,
      105,
      230,
      { align: 'left' }
    );

    doc.text(
      `Contas Pagar: ${data?.erp?.erpContasPagar}`,
      15,
      235,
      { align: 'left' }
    );

    doc.text(
      `Pagamento Escritural: ${data?.erp?.erpPagamentoEscritural}`,
      105,
      235,
      { align: 'left' }
    );

    doc.text(
      `Contas Receber: ${data?.erp?.erpContasReceber}`,
      15,
      240,
      { align: 'left' }
    );

    doc.text(
      `Tesouraria: ${data?.erp?.erpTesouraria}`,
      105,
      240,
      { align: 'left' }
    );

    doc.text(
      `Integração Padrão: ${data?.erp?.erpIntegracaoPadrao}`,
      15,
      245,
      { align: 'left' }
    );

    doc.text(
      `Contábil: ${data?.erp?.erpContabil}`,
      105,
      245,
      { align: 'left' }
    );

    doc.text(
      `Estoque: ${data?.erp?.erpEstoque}`,
      15,
      250,
      { align: 'left' }
    );

    doc.text(
      `Patrimônio: ${data?.erp?.erpPatrimonio}`,
      105,
      250,
      { align: 'left' }
    );

    doc.text(
      `Orçamento: ${data?.erp?.erpOrcamento}`,
      15,
      255,
      { align: 'left' }
    );

    doc.text(
      `REINF: ${data?.erp?.erpReinf}`,
      105,
      255,
      { align: 'left' }
    );

    doc.text(
      `EFD: ${data?.erp?.erpEfd}`,
      15,
      260,
      { align: 'left' }
    );

    doc.text(
      `ECD: ${data?.erp?.erpEcd}`,
      105,
      260,
      { align: 'left' }
    );

    doc.text(
      `ECF: ${data?.erp?.erpEcf}`,
      15,
      265,
      { align: 'left' }
    );
  }

  window.open(URL.createObjectURL(doc.output(
    'blob',
    {
      filename: `chamado${includeLeftZero(data.numeroChamado)}`
    }
  )));

  // doc.save(`chamado${includeLeftZero(data.numeroChamado)}`);
};

export default makePdf;
